/* eslint-disable react-hooks/exhaustive-deps */
import { components, CSSObjectWithLabel, DropdownIndicatorProps, GroupBase } from 'react-select';
import React, { useState, useEffect } from 'react';

import { UiSearch } from '@vyaguta/vyaguta-icons/ui';

import DropDown from 'components/common/dropDown';
import { GroupedDropdownOption } from 'components/common/dropDown/Dropdown';

import { handleError } from 'utils/errorHandler';
import { EndLevelSkillType, generateReactSelectSkillGroupOptions } from 'utils/reactSelect';

import useDataState from 'hooks/useDataState';

import * as skillV2Service from 'services/skillV2';

interface SkillOption {
  label: string;
  value: number | string;
}

export type { SkillOption };

const DropdownIndicator = (dropdownProps: DropdownIndicatorProps<SkillOption, boolean, GroupBase<SkillOption>>) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...dropdownProps} className="px-8">
        <UiSearch />
      </components.DropdownIndicator>
    )
  );
};

interface Props {
  setSelectedSearchSkill: (option: SkillOption | null) => void;
  selectedSearchSkill?: SkillOption | null;
  triggerSearchSkillTree?: number;
}

function SearchSkill(props: Props) {
  const { setSelectedSearchSkill, selectedSearchSkill, triggerSearchSkillTree } = props;

  const [searchInput, setSearchInput] = useState('');

  const { data, setData, isLoading, setIsLoading } = useDataState<EndLevelSkillType>();

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);

        const { data: fetchedData } = await skillV2Service.fetchEndLevelSkills();

        setData(fetchedData as EndLevelSkillType[]);
      } catch (error) {
        handleError(error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [triggerSearchSkillTree]);

  const skillOptions = generateReactSelectSkillGroupOptions(data, true) as GroupedDropdownOption[];

  return (
    <DropDown
      // Open dropdown menu when input text length is more than or equal to 3
      menuIsOpen={!!searchInput.length}
      options={skillOptions}
      isSearchable
      isClearable
      isLoading={isLoading}
      isDisabled={isLoading}
      value={selectedSearchSkill}
      isBigSearchBox
      components={{
        DropdownIndicator,
      }}
      onDropDownChange={(option) => {
        setSelectedSearchSkill(option as SkillOption | null);
      }}
      onInputChange={(string: string) => {
        setSearchInput(string);
      }}
      customStyles={{
        control: (base: CSSObjectWithLabel) => ({
          ...base,
          flexDirection: 'row-reverse',
        }),
        dropdownIndicator: (base: CSSObjectWithLabel) => ({
          ...base,
          padding: '0 8px',
        }),
        clearIndicator: (base: CSSObjectWithLabel) => ({
          ...base,
          padding: '0 8px',
          position: 'absolute',
          right: 0,
        }),
        valueContainer: (base: CSSObjectWithLabel) => ({
          ...base,
          padding: '0',
          marginRight: '20px',
        }),
        indicatorsContainer: (base: CSSObjectWithLabel) => ({
          ...base,
          display: 'flex',
          flexDirection: 'row-reverse',
        }),
      }}
    />
  );
}

export default SearchSkill;
